// src/components/Skills.js
import React from 'react';
import './skills.css';

const Skills = () => {
  return (
    <section>
      <h2>Skills</h2>
      <ul>
        <li>HTML5</li>
        <li>CSS3</li>
        <li>JavaScript</li>
        <li>React</li>
        <li>PHP</li>
        <li>Laravel</li>
        <li>Wordpress</li>
        <li>Wix</li>
        <li>Hetzner, WHM, Azure</li>
        <li>CakePHP</li>
        <li>API development</li>
        <li>MySql</li>
        <li>Database Management</li>
        <li>SEO</li>
        <li>SMM</li>
        {/* Add more skills as needed */}
      </ul>

   
    </section>
  );
};

export default Skills;
